export const defaultPropertiesAction = {
  dataset_type: 'Workflow Data',
  content_type: 'Calendars',
  entity_type: 'Action'
}

export const defaultPropertiesReport = {
  dataset_type: 'Workflow Data',
  content_type: 'Reporting',
  entity_type: 'Report'
}

export const ACTION_CREATE_PAGE_EVENT = 'Actions Create Page'
